import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setResult(r.data);
      toast.success("Şifre sıfırlama bilgileri gönderildi");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-8">
      <form onSubmit={submit} className="bg-white border border-gray-100 rounded-lg p-8 shadow-sm w-full max-w-md">
        <div className="flex justify-center mb-5"><Logo size="lg" /></div>
        <h1 className="text-2xl font-black text-center mb-1">Şifremi Unuttum</h1>
        <p className="text-sm text-gray-500 text-center mb-6">Email adresinize şifre sıfırlama bağlantısı gönderelim</p>
        <label className="block text-sm font-medium mb-1">Email</label>
        <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm mb-4" />
        <button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full px-4 py-2.5 bg-[#e11d2a] text-white rounded-md font-semibold hover:bg-[#b8161f]">{loading ? "Gönderiliyor..." : "Bağlantı Gönder"}</button>
        {result?.reset_link && (
          <div className="mt-4 bg-amber-50 border border-amber-200 rounded p-3 text-xs">
            <div className="font-bold text-amber-900">SMTP yapılandırılmadığı için:</div>
            <Link to={`/sifre-sifirla?token=${result.reset_token}`} className="text-[#e11d2a] underline break-all">Şifreyi sıfırlamak için tıklayın</Link>
          </div>
        )}
        {result && !result.reset_link && (
          <div className="mt-4 bg-green-50 border border-green-200 rounded p-3 text-sm text-green-800">{result.message}</div>
        )}
        <div className="mt-4 text-sm text-center">
          <Link to="/giris" className="text-[#e11d2a] font-semibold">Girişe dön</Link>
        </div>
      </form>
    </div>
  );
}
